/**
 * @ngdoc service
 * @name cart:CartFactory
 *
 * @description
 *
 *
 * */
(function () {
    'use strict';

    angular
        .module('exhibitorRegistrationApp')
        .factory('CartFactory', CartFactory);

    CartFactory.$inject = ['$localStorage', '$log', 'CartHTTPService'];

    function CartFactory($localStorage, $log, CartHTTPService) {

        //delete $localStorage.cart;

        var service = {
            getCart: getCart,
            addItem: addItem,
            updateItemByIndex: updateItemByIndex,
            addFee: addFee,
            removeItem: removeItem,
            count: count,
            totalPrice: totalPrice,
            book: book,
            countAreas: countAreas,
            removeCoExhibitorBookings: removeCoExhibitorBookings,
            clear: clear
        };

        return service;

        // returns all items in this cart for the completion page
        function getCart() {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            return $localStorage.cart;
        }

        // adds an item into the cart
        function addItem(item) {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            $log.debug('CartFactory | Adding item: ', item);
            $localStorage.cart.push(item);
        }

        // adds an item into the cart
        function updateItemByIndex(index, item) {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            $log.debug('CartFactory | Updating item old/new: ', $localStorage.cart[index], item);
            $localStorage.cart[index] = item;
        }

        // removes an item
        function removeItem(item) {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            $log.debug('CartFactory | Removing item: ' + item);
            var count = 0;
            angular.forEach($localStorage.cart, function (value) {
                if (value == item) {
                    $localStorage.cart.splice(count, 1);
                }
                count++;
            });
        }

        // Return how many items are currently in this cart
        function count() {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            return $localStorage.cart.length;
        }

        // Returns the total price of all items in this cart
        function totalPrice() {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            var price = 0;

            angular.forEach($localStorage.cart, function (value) {
                if (value != null && value.cartPositionPrice != null)
                    price += value.cartPositionPrice;
            });
            return price;
        }

        function countAreas() {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            var count = 0;

            angular.forEach($localStorage.cart, function (value) {
                if (value != null && value.type != null && value.type == 'Area')
                    count ++;
            });
            return count;
        }

        function removeCoExhibitorBookings(id) {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }

            var index = $localStorage.cart.length - 1;

            while (index >= 0) {
                if ($localStorage.cart[index].cartPositionBookedForId === id) {
                    $localStorage.cart.splice(index, 1);
                }

                index -= 1;
            }
        }

        function addFee(item) {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            $log.debug('CartFactory | Adding fee: ', item);
            var addToCart = true;
            if (item.type == 'Fee') {
                angular.forEach($localStorage.cart, function (value) {
                    if (value.type == 'Fee') {
                        addToCart=false;
                        return;
                    }
                });
            } else if (item.type == 'CoExhibitorFee') {
                angular.forEach($localStorage.cart, function (value) {
                    if (value.type == 'CoExhibitorFee' && value.cartPositionBookedForId == item.cartPositionBookedForId) {
                        value.coExhibitor = item.coExhibitor;
                        value.cartPositionBookedFor = item.cartPositionBookedFor;
                        value.cartPositionBookedForId = item.cartPositionBookedForId;
                        addToCart=false;
                        return;
                    }
                });
            }
            if (addToCart)
                $localStorage.cart.unshift(item);
        }

        function book() {
            if ($localStorage.cart === undefined) {
                $localStorage.cart = [];
            }
            return CartHTTPService.save($localStorage.cart);
        }

        function clear() {
            delete $localStorage.cart;
        }
    }
})();
